module.exports = __webpack_public_path__ + "assets/logo-feelgood-print.eps?6d8d617c4acbe7f774ac62c543199c58";